import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(() => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    gap: rem(16),
  },
  filter: {
    display: 'flex',
    flexFlow: 'column',
    gap: rem(24),
  },
  filterButton: {
    zIndex: 3,
    filter: 'drop-shadow(0px 4px 8px rgba(24, 24, 27, 0.04))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
